module.exports = __webpack_public_path__ + "img/recharge.b191bcdc.png";